export default (top: number = 0) =>
  setTimeout(
    () =>
      window.scrollTo({
        behavior: "smooth",
        top,
      }),
    100
  );
